import { render } from "./EditContact.vue?vue&type=template&id=21479bfa&ts=true"
import script from "./EditContact.vue?vue&type=script&lang=ts"
export * from "./EditContact.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__